// removed by extract-text-webpack-plugin
module.exports = {"event-limit-notification":"event-limit-notification","subscription-description":"subscription-description","button-subscription":"button-subscription"};


//////////////////
// WEBPACK FOOTER
// ./src/application/component/notifications/component/event-limit-notification/event-limit-notification.style.sass
// module id = sO6y
// module chunks = 0